<mat-expansion-panel hideToggle class="price-filter box-shadow" [expanded]="true" (closed)="priceExpanded = false" (opened)="priceExpanded = true">
  <mat-expansion-panel-header >
    <mat-panel-title>{{ 'globalUi.filter.price' | translate }}</mat-panel-title>
    <mat-panel-description fxFlex="">
      <span fxFlex=""></span>
      @if (!priceExpanded) {
        <img alt=""  src="assets/icons/add-24px-2.svg">
      } @else {
        <img alt="" src="../../../../assets/icons/close-icon.svg" >
      }
    </mat-panel-description>

  </mat-expansion-panel-header>

  <div fxLayout="row wrap" fxLayoutAlign="space-between">
    <div fxFlex="49%" fxFlex.lg="46">
      <mat-form-field appearance="fill" class="price-input" >
        <input #minInput matInput [placeholder]="'globalUi.filter.min' | translate"  [ngModel]="minPrice" (ngModelChange)="showFilterBtn = true" type="number"  autocomplete="off" >
        <span matSuffix>&nbsp;{{ 'globalUi.currency' | translate }}</span>

      </mat-form-field>
    </div>
    <div fxFlex="49%" fxFlex.lg="30">
      <mat-form-field appearance="fill" class="price-input">
        <input #maxInput matInput [placeholder]="'globalUi.filter.max' | translate" [ngModel]="maxPrice" (ngModelChange)="showFilterBtn = true" type="number" autocomplete="off">
        <span matSuffix>&nbsp;{{ 'globalUi.currency' | translate }}</span>
      </mat-form-field>
    </div>

    <button mat-button class="apply-btn"   (click)="hideSideNavFilter() ;applyFilter();  showFilterBtn = !showFilterBtn" [ngStyle]=" {'display': showFilterBtn ? 'block' : 'none'}" >

      <span>{{ 'globalUi.filter.apply' | translate }}</span>
    </button>
    <ngx-slider fxFlex="100%"
      [(value)]="minPrice"
      [(highValue)]="maxPrice"
      [options]="sliderOptions"
      (userChange)="sliderListener()">
    </ngx-slider>


  </div>


</mat-expansion-panel>

